<div class="grid-row padding-top-205">

  <div class="desktop:grid-col-3 tablet-lg:grid-col-12 mobile-lg:grid-col-12 margin-bottom-3">
    <sam-frontend-admin-notifications-filter [fields]="fields" (filterEvent)="onFilterChange($event)"></sam-frontend-admin-notifications-filter>
  </div>

  <sds-page class="sds-page condensed desktop:grid-col-9">

    <!-- not following records -->
    <ng-template #temp>
      <div>
        <hr>
        <h6 class="usa-label font-sans-2xs text-italic text-base" [tabIndex]="0">
          You currently do not have any notifications.
        </h6>
      </div>
    </ng-template>

    <!-- MOBILE HEADER BLOCK -->
    <div *ngIf="isMobileResolution" class="header-block">
      <div class="grid-row grid-gap display-flex flex-row">
        <div class="grid-col-6 align-bottom">
          <h1 class="screenreader">Notifications</h1>
          <!-- top pagination -->
          <sds-pagination class="result-container padding-right-2" displayMode='results' [(page)]="page"
            (pageChange)="onPageNumChange($event)" [totalItems]="totalRecords" [tabIndex]="0">
          </sds-pagination>
          <div aria-live="polite">
            <div class="no-results-display text-semibold" *ngIf="!notificationData || notificationData.length == 0">
              Showing &nbsp;0&nbsp;-&nbsp;0&nbsp; of&nbsp; 0&nbsp; results </div>
          </div>
        </div>

        <!-- Sort by -->
        <div class="grid-col-6 float-right">
          <div class="sds-field">
            <form class="usa-form">
              <label class="usa-label font-sans-2xs text-italic text-base" for="notificationSort">Sort
                By</label>
              <select class="usa-select" name="options" id="notificationSort" [(ngModel)]="selectedSort"
                (ngModelChange)="loadNotificationData()">
                <option *ngFor="let option of SortConfiguration" [ngValue]="option">{{option.label}}
                </option>
              </select>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop HEADER BLOCK -->
    <div *ngIf="!isMobileResolution" class="header-block">
      <div class="grid-row display-flex flex-row margin-top-neg-6">
        <div class="tablet:grid-col-4 grid-col-12">
          <h1 class="screenreader">Notifications</h1>
          <!-- top pagination -->
          <sds-pagination class="result-container padding-right-2" displayMode='results' [(page)]="page"
            (pageChange)="onPageNumChange($event)" [totalItems]="totalRecords" [tabIndex]="0">
          </sds-pagination>
          <div class="no-results-display text-semibold" aria-live="polite" *ngIf="!notificationData || notificationData.length == 0"
            [tabIndex]="0">
            Showing &nbsp;0&nbsp;-&nbsp;0&nbsp; of&nbsp; 0&nbsp; results </div>
        </div>

        <!-- Sort by -->
        <div class="tablet:grid-col-8 grid-col-12">
          <div class="sds-field float-right padding-left-2">
            <form class="usa-form">
              <label class="usa-label font-sans-2xs text-italic text-base" for="notificationSort">Sort
                By</label>
              <select class="usa-select" name="options" id="notificationSort" [(ngModel)]="selectedSort"
                (ngModelChange)="loadNotificationData()">
                <option *ngFor="let option of SortConfiguration" [ngValue]="option">{{option.label}}
                </option>
              </select>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Notifications -->
    <sds-search-result-list [model]="notificationData" [customResultsTemplate]="temp" *ngIf="!initLoad; else loadingScreen">
      <ng-template #resultContent let-item>
        <div (click)="(item && item?.link && item?.link.trim() != '') ? redirectToView(item?.link) : ''"
             [ngClass]="(item && item?.link && item?.link.trim() != '') ? 'pointer-cursor' : 'default-cursor'"
             [tabindex]="0">
          <!-- first row -->
          <div class="grid-row margin-top-1">
            <div class="grid-col-12">
              <p class="margin-bottom-3" [innerHTML]="item?.feeds"></p>
            </div>
          </div>
          <!-- second row -->
          <div class="grid-row margin-bottom-1">
            <div class="grid-col-12">
              <small><em>{{item?.createdDate| date:"MMM d, y h:mm a"}}</em></small>
            </div>
          </div>
        </div>
      </ng-template>
    </sds-search-result-list>

    <ng-template #loadingScreen>
      <div class="grid-container" *ngFor="let a of loading; let index = index">
        <hr>
        <div class="sds-load grid-row">
          <div class="grid-col-7 height-4 sds-load__content"></div>
          <div class="grid-col-5"></div>
        </div>
        <br>
        <div class="sds-load grid-row">
          <div class="grid-col-4 sds-load__content"></div>
          <div class="grid-col-5"></div>
        </div>
      </div>
    </ng-template>

    <sds-pagination *ngIf="notificationData?.length" [paginationConfiguration]="bottom" [(page)]="page" (pageChange)="onPageNumChange($event)">
    </sds-pagination>
  </sds-page>
</div>
